import '../plugins/AddClassesPlugin.js';

// add class on click
export default function initAddClasses() {
	jQuery('a.search-opener').clickClass({
		classAdd: 'search-active',
		addToParent: 'body'
	});
}